module.exports = __webpack_public_path__ + "static/media/buy-deliver.f2d79633.svg";